<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="fm"><b>Also by Iain Levison</b></p>
<p class="ser"><i>A Working Stiff’s Manifesto</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c3.vue?bc079fd0